import { Box, Flex, Grid, Skeleton, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export const PlansListSkeleton = () => {
  const { t } = useTranslation('cross-seller/plans');
  return (
    <Flex flexDir="column" gap={4}>
      <Text color="brand.800" fontSize="2xl" fontWeight={600}>
        {t('availablePlans')}
      </Text>
      <Box maxH="calc(100dvh - 324px)" overflowY="auto" h="100dvh">
        <Grid templateColumns={{ lg: 'repeat(2, 1fr)' }} gap={4}>
          {[1, 2, 3, 4, 5, 6].map(index => (
            <Skeleton
              key={index}
              height={200}
              borderRadius={12}
              boxShadow="xl"
            />
          ))}
        </Grid>
      </Box>
    </Flex>
  );
};
